import React from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
//style="text-align: center;"

export const agreement = type => {
  document.title = '規約（反社会的勢力の排除・個人情報取り扱いなど）｜エリアリンク｜トランクルームをお探しなら『ハローストレージ』【公式】';
  const typeString = type === TYPE_PC ? "pc" : "sp";
  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "重要事項確認書" }])}

      <div className="agreement">
        <p id="contentsHead">重要事項確認書
        <a className="link_pdf" href="/resource/img/static/agreement/jyuuyou_jikou_kakuninsyo_20240110.pdf" target="_blank">ダウンロード</a>
        </p>
        <div id="agreementBox">
          <h1>【　契約に関する確認事項　】</h1>
          <h2>➢&nbsp;申込キャンセルについて（契約約款第5条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "01.png?20230401"} /></div>
          <h2>➢&nbsp;利用料金について（契約約款第7条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "02.png?20240110"} /></div>
          <h2>➢&nbsp;キャンペーンの適用及び終了について（契約約款第25条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "03.png?20201218"} /></div>
          <h2>➢&nbsp;契約の更新について（契約約款第5条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "04.png?20201218"} /></div>
          <h2>➢&nbsp;解約について（契約約款第6条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "05.png?20240110"} /></div>
          <h2>➢&nbsp;契約の終了について（契約約款第24条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "06.png?20201218"} /></div>
          <h2>➢&nbsp;契約の解除について（契約約款第23条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "07.png?20201218"} /></div>
          <br/>
          <h1>【　利用に関する確認事項　】</h1>
          <h2>➢&nbsp;禁止収納物について（契約約款第13条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "08.png?20240110"} /></div>
          <h2>➢&nbsp;立入り・本件サービスの停止について（契約約款第22条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "09.png?20201218"} /></div>
          <h2>➢&nbsp;届出事項の変更（報告義務）について（契約約款第15条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "10.png?20201218"} /></div>
          <br/>
          <h1>【　保険内容に関する確認事項　】</h1>
          <h2>➢&nbsp;保険の付保について（契約約款第18条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "13.png?20230401"} /></div>
          <br/>
          <h1>【　コンプライアンスに関する確認事項　】</h1>
          <h2>➢&nbsp;反社会的勢力の排除について（契約約款第20条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "12.png?20210624"} /></div>
          <h2>➢&nbsp;個人情報の取扱について（契約約款第26条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "11.png?20210624"} /></div>
          <h2>➢&nbsp;カスタマーハラスメントに対する指針（契約約款第21条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "15.png?20240110"} /></div>
          <br />
          <h1>【　安心保証パック特約に関する確認事項　】</h1>
          <h2>➢&nbsp;事務手数料無料サービスの例外について（安心保証パック約款第6条）</h2>
          <div className={"scroll" + typeString} ><img className={"img" + typeString} src={"resource/img/static/agreement/agreement_" + typeString + "14.png?20210624"} /></div>
          <div className="kiyakuDetail">
            <h2>レンタルボックス使用契約約款
            <a className="link_pdf2" href="/resource/img/static/agreement/yakkan_20240110.pdf" target="_blank">ダウンロード</a>
            </h2>
            <dl>
              <dt>第1条（総則）</dt>
              <dd>
                <p>
                  本レンタルボックス使用契約約款（以下「本約款」といいます）は、エリアリンク株式会社（以下「当社」といいます）と、当社が提供する「レンタルボックス使用サービス」及びこれに付随するオプションサービス（以下総称して「本件サービス」といいます）の利用をレンタルボックス使用契約申込書（当社ホームページからの申込みまたは電話にて申込後、使用契約申込書を当社へ提出する場合を含む。以下「使用契約申込書等」といいます）により本約款を契約の内容とすることを承諾のうえで申込み、当社がこれを承諾した個人又は法人（以下「契約者」といいます）との間における、本件サービスの利用に関する「レンタルボックス使用契約」（以下「本契約」といいます）に対して適用されます。但し、別途契約者と当社の間で締結された書面による特約がある場合は、当該特約が優先して適用されます。
                </p>
                <p>
                  2.本契約は契約者が使用契約申込書等にて申込みを行い当社が承諾した時に成立します。ただし、電話にて申込みを行う場合には、契約者は当社が指定した時期までに使用契約申込書を当社へ提出するものとします。また、当社による承諾が電子メールを発する方法によって行う場合については、電子メールが契約者に到達した時点で成立します。
                </p>
                <p>
                  3.契約者は本契約の締結前に必ず本約款の内容を確認するものとし、本契約を締結した時点もしくは本件サービスの利用を開始した時点以降は契約者に対して本約款を適用します。
                </p>
                <p>
                  4.当社は本約款を変更することがあります。この場合、当社は契約者への書面（電子メールを含む）による通知または当社ホームページにおいて本約款を変更する旨及び変更後の本約款の内容並びにその効力発生日 の告知を行うものとし、かかる効力発生日以降は、変更後の約款が適用され、契約者は変更後の約款を承認して本件サービスを利用するものとみなされます。
                </p>
                <p>
                  5.当社は、本契約の申込者が、以下の各号のいずれかの事由に該当する場合は、本契約の申込みを承諾しないことがあり、またその理由について一切開示義務を負いません。<br />
                  &#9312; 当社に提供された登録事項、必要書類等の全部又は一部につき虚偽、誤記又は記載漏れがあった場合。<br />
                  &#9313; 未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人、保佐人又は補助
                  人の同意等を得ていなかった場合（なお、成年被後見人の場合、本契約は申込者の法定代理人である後見人
                  との間で行うものとします）。<br />
                  &#9314;申込者において、本約款を含む当社の各種約款、本契約、及び誓約書等の内容に対する同意がない場合、又
                  はこれらの内容を十分に理解していないなど有効な同意を行っていない合理的な疑いが認められる場合。<br />
                  &#9315; 前各号に掲げるほか、レンタルボックス使用サービスの利用の承諾が客観的合理的に適当でないと当社が判
                  断する場合。
							</p>
              </dd>
              <dt>第2条（定義）</dt>
              <dd>
                <p>
                  以下に掲げる各用語は、本約款において以下に定める意味を有するものとします。
                </p>
                <ul>
                  <li>
                    &#9312;「レンタルボックス使用サービス」とは、当社が契約者に対し当社のレンタルボックスを一時的に使用していただき、物品類の収納スペースを提供するサービスをいいます。
                  </li>
                  <li>
                    &#9313;「レンタルボックス」とは、本契約の定めに基づき、当社が契約者に一時使用して頂く使用区画（レンタル収納スペース）をいいます。
                  </li>
                  <li>
                    &#9314;「屋外型トランクルームタイプ」とは、本件サービスにおいて当社が屋外に設置したコンテナを利用して契約者に提供する、レンタルボックスのタイプをいいます。
                  </li>
                  <li>
                    &#9315;「屋内型トランクルームタイプ」とは、本件サービスにおいて当社が屋内に設置した仮設の造作によって間仕切りした使用区画を利用して提供する、レンタルボックスのタイプをいいます（倉庫業法第２条第３項にいう「トランクルーム」を意味しません）。
                  </li>
                  <li>
                    &#9316;「収納物」とは、本件サービスにおいてレンタルボックスに収納された物品類をいいます。
                  </li>
                </ul>
              </dd>
              <dt>第3条（基本事項の確認）</dt>
              <dd>
                <p>
                  本件サービスは、当社が契約者に対し物品類を収納することができるスペースを一時使用のために提供するものであって、いかなる意味においても、当社が契約者より収納物を預かるものでも、契約者の収納物を保管するものでもありません。
                  <br />
                  したがって、本件サービスにおいて、収納物の管理責任者及び直接占有者は契約者ご自身となります。
                  <br />
                  また、契約者の自己責任の下、収納物が滅失、毀損等により損害が生じた場合、または当社に責任があるものの当社の責任限度額（第16条）を超える損害が発生した場合は、当社に故意又は重過失があった場合を除き、契約者の責任となり当社はその責任を負いません。
                </p>
                <p>
                  2.レンタルボックスの利用はタイプを問わず、その法的性質上、借地借家法の適用は受けません。
                </p>
                <p>
                  3.当社は、レンタルボックスが存する建物（以下当建物」といいます）を第三者（以下「新所有者」といいます）に譲渡（信託銀行等への信託譲渡を含みます）しつつ、当該新所有者との間で、契約者に対するレンタルボックスの賃貸人たる地位を当社に留保する旨及び当建物を新所有者が当社に賃貸する旨の合意をする場合があります。<br />
                  その場合、レンタルボックスの貸主の地位が当社に留まることにつき契約者はあらかじめ同意するものとします。
                </p>
                <p>
                  4.上記3.の場合、当社と契約者との間の賃貸借は転貸借となりますが、契約条件は従前と変わりません。<br />
                  保証金をお預かりしている場合は、その返還債務は従前と同様に当社のみが負い、新所有者は保証金の返還債務を負いません。また、当社と新所有者との間の賃貸借が終了した場合、当社に留保されていたレンタルボックスの賃貸人たる地位は、新所有者又はその承継人に移転するものとします。
                </p>
                <p>
                  5.上記3.の場合、当社は契約者に対して、当建物が新所有者に譲渡されたこと、譲渡後に当社が新所有者から当建物を賃借したこと、当社と契約者との間の賃貸借は転貸借となったこと等を本約款に定める方法により通知するものとします。
                </p>
              </dd>
              <dt>第4条（使用目的）</dt>
              <dd>
                当社は契約者に対して、使用契約申込書等記載のレンタルボックスを契約者が物品類（但し、第１３条の禁止収納物を除きます。以下同じとします。）を収納する一時使用目的にて賃貸し、契約者はこれを借り受けます。
              </dd>
              <dt>第5条（契約期間及びキャンセル料の支払い）</dt>
              <dd>
                <p>
                  契約期間は、使用契約申込書等記載の期間とします。但し、契約期間満了の日の１ヶ月前までに、当社、契約者のいずれよりも解約の申出がなく、かつ契約者が引続き利用資格を有すると当社が認めた場合は、本契約は更に１年間更新されるものとし、その後も同様とします。
                </p>
                <p>
                  2.契約者は、契約成立後、前項の契約期間開始前に本契約を解約する場合には、当社に対し当社所定のキャンセル料（5,000円税込）を支払うものとします。
                </p>
              </dd>
              <dt>第6条（期間内解約）</dt>
              <dd>
                <p>
                契約期間中といえども、契約者または当社はその理由のいかんを問わず、相手方に対し事前に電話又はマイページからのWEB申請で通知を行うことで本契約を解約できるものとします。この場合、相手方に当該通知が到達した日の翌月末日にて本契約は終了します。ただし、左記期日より後の月を解約希望月とした場合は、当該解約希望月の末日にて本契約は終了します。<br/>
                また、解約を申し出られた後に解約の手続きを取りやめることはできません。
                </p>
                <p>
                  2.契約者及び当社は前項の予告期間にかえ１ヶ月分の使用料および管理料相当額を解約希望日までに相手方に支払い、即時解約することができるものとします。
                </p>
                <p>
                  3.前二項の解約による解約申し出を受領した場合においても、解約日が本契約の期間終了日以降となった際には、契約者は第７条&#9318;に記載する更新料を支払うものとします。
                </p>
              </dd>
              <dt>第7条（利用料金）</dt>
              <dd>
                <p>
                  契約者は、当社に対し、本サービスの利用に関して、以下の各料金（以下総称して「利用料金」という）を当社の指定日までに支払うものとします。
                </p>
                <ul>
                  <li>
                    &#9312;月額使用料：レンタルボックスの毎月の使用料。
                  </li>
                  <li>
                    &#9313;月額管理費：レンタルボックス及び共用部における維持管理費用。
                  </li>
                  <li>
                    &#9314;事務手数料：本契約の締結（レンタルボックスの変更及びレンタルボックスの追加申込の場合を含む）その他事務処理のための手数料（月額使用料の１ヶ月分）。
                  </li>
                  <li>
                    &#9315;安心保証パック特約料：当社が別途定める安心保証パック特約が付された契約者について、安心保証パックサービス料金（月額550円税込）。
                  </li>
                  <li>
                    &#9316;安心保証パックプラス特約料：当社が別途定める安心保証パックプラス特約が付された契約者について、安心保証パックプラスサービス料金（月額880円税込）。
                  </li>
                  <li>
                    &#9317;室内整備料：安心保証パック特約又は安心保証パックプラス特約が付されていない契約者について、原状回復費用とは別にレンタルボックス内の汚損等の有無及び程度を問わず、専門業者による室内整備（点検、シート張替、クリーニング等）等の対応費となるレンタルボックス整備料（8,800円税込）。
                  </li>
                  <li>
                    &#9318;更新料：本契約期間が終了し翌年度へ更新する時点で要する手数料（月額使用料の0.5ヶ月分）。
                  </li>
                  <li>
                    &#9319;その他：前記の料金以外の料金の金額に関しては、使用契約申込書等または当社作成の別途書面等（電磁的方法によるものを含む。）により定める費用。
                  </li>
                </ul>
                <p>
                  2.本条第1項に定める他、当社の判断にて契約者の同意を得た上で、契約者と金銭支払債務の連帯保証会社との
                  間に保証委託契約を締結していただく場合があります。<br />
                  契約内容及び保証料等の詳細については別途締結する保証委託契約書をご参照ください。
                </p>
              </dd>
              <dt>第8条（支払方法）</dt>
              <dd>
                利用料金の支払いは、別途定めた場合を除き以下のとおりとします。
                <ul>
                  <li>
                    &#9312;契約者は、契約期間開始前までに、初期費用として、月額使用料（初月の日割分及び翌月分）、月額管理費（初月分及び翌月分）、事務手数料、安心保証パック特約料又は安心保証パックプラス特約料（初月分及び翌月分、但し安心保証パック特約又は安心保証パックプラス特約が付されている場合に限ります）及び前条⑧に基づき定める費用を、振込用紙による支払い、当社指定の口座へのお振込みまたはクレジットカード払いのいずれかの方法で当社に支払うものとします。
                  </li>
                  <li>
                    &#9313;契約者は、翌月分の月額使用料及び月額管理費並びに安心保証パック特約を付された契約者は安心保証パック特約料(初期費用を除く)を、毎月27日（金融機関の休業日にあたる場合は翌金融機関の営業日）に自動引落（当社が指定する集金代行会社による自動引落の場合を含む）により、または毎月15日（金融機関の休業日にあたる場合は翌金融機関の営業日）クレジットカード払いにより毎月継続して支払うものとします。
                  </li>
                  <li>
                    &#9314;契約者は、本契約が更新されるときは、更新期間開始前の月の27日（金融機関の休業日にあたる場合は翌金融機関の営業日）に自動引落（当社が指定する集金代行会社による自動引落の場合を含む）により、または更新期間開始前の月の15日（金融機関の休業日にあたる場合は翌金融機関の営業日）にクレジットカード払いにより更新料を支払うものとします。
                  </li>
                  <li>
                    &#9315;残高不足等により自動引落ができない場合は、契約者は直ちに未払金を使用契約申込書に記載する振込口座に振込んで支払うものとします。
                  </li>
                </ul>
                <p>
                  2.１ヶ月未満の月額使用料は当該月の実日数に関わらず月30日の日割計算とします。なお、管理費は、契約者の契約期間が１ヶ月に満たない場合であっても、日割計算はいたしません。
                </p>
                <p>
                  3.利用料金その他契約者より当社への支払いに伴う自動引落、口座振込等の手数料はすべて契約者の負担とします。また、第10条第４項の保証金の返還その他当社より契約者への支払いに伴う口座振込等の手数料についても、すべて契約者の負担とします。契約者が当社に支払う金銭について、本件サービス利用に関する債務の弁済に充当する順序は当社が適当と認める順序により行います。また債務の弁済時期および方法の変更は、当社の任意ですることができます。
                </p>
              </dd>
              <dt>第9条（利用料金の改定）</dt>
              <dd>
                契約期間中であっても、物価の変動、使用料相場の変更、経済情勢の変化、公租公課等の増減、近隣事例に比較して不相当となった場合、または諸事情により当社が利用料金を変更する必要が生じた場合には、当社は契約者に書面(電子メールを含む)による60日以上前の事前の予告により利用料金の金額を改定することができます。
                <p>
                  2.本契約の対象であるレンタルボックス以外の未契約のレンタルボックス利用料金は諸事情により変動しますが、本契約の対象となるレンタルボックスの利用料金は当該変動の影響を受けません。
                </p>
              </dd>
              <dt>第10条（保証金）</dt>
              <dd>
                <p>
                  契約者は当社に対し本契約締結までに本契約の履行を担保するため、定められた保証金を当社に預け入れるものとします。但し、クレジットカードにて初期費用の支払いを行った場合には、保証金の預託は不要とします。
                </p>
                <p>
                  2.契約者に利用料金の遅延、損害賠償義務の不履行、その他本契約に基づく債務の不履行があるときは、当社はなんらの催告なしに保証金をこれに充当できるものとします。
                  <br />
                  この場合、契約者は充当の通知を受けた日から１週間以内に保証金の不足額を填補するものとします。なお、契約者は保証金をもって利用料金その他の債務との相殺を主張することが出来ません。
                </p>
                <p>
                  3.契約者は保証金に関する債権を第三者に譲渡し、または債務の担保の用に供してはならないものとします。
                </p>
                <p>
                  4.本契約が終了したときは、当社は契約者に対して、レンタルボックスの明渡し後90日以内に、契約者の未払金、その他の本契約から発生した金銭債務を控除した残金を返還（振込手数料は契約者負担）します。但し、契約者の連絡先または契約者の相続人が不明等の理由により、保証金その他当社から契約者に返還すべき金銭(以下「保証金等」といいます)を契約者に返還することができない場合には、本契約の終了日から5年間の経過をもって、当該保証金等の返還請求権の債権を放棄したものとみなします。
                </p>
                <p>
                  5.本契約締結時において保証金の預け入れを定めていない場合であっても、利用料金の支払い方法の変更等、契約内容に変更が生じた場合には、当社は契約者に相当な保証金の預け入れを請求することができます。
                </p>
              </dd>
              <dt>第11条（遅延損害金）</dt>
              <dd>
                <p>
                  契約者が、利用料金その他本件サービスに基づき当社に対し支払うべき一切の金銭の支払いを遅延した場合、当社は支払期日の翌日から支払日に至るまで遅延金に対し年率14.6％（年365日の日割計算）を乗じた額の遅延損害金を請求することができます。
                </p>
              </dd>
              <dt>第12条（特別出動）</dt>
              <dd>
                <p>
                  契約者の故意または過失により、当社または当社が委託した者が緊急に出動した場合、当社は契約者に対し１回の出動につき金１6,500円（税込み）の費用を請求することができます。なお、必ずしも当社または当社が委託した者は、即時の出動もしくは契約者が希望する日時に出動することに応じるものではありません。
                </p>
                <p>
                  2.前項の金額を超える費用については、当社は別途契約者に対し追加費用を請求することができます。
                </p>
              </dd>
              <dt>第13条（禁止収納物）</dt>
              <dd>
                <p>
                  契約者は以下の物品類をレンタルボックスに収納することはできません。
                </p>
                <ul>
                  <li>
                    &#9312;収納物の総額（購入価格を基準として時価算定）が40万円を上回るもの、かつ1個または1組の価額が20万円を超えるもの
                  </li>
                  <li>
                    &#9313;現金（通貨）・預貯金証書・クレジットカード・高額貴金属・宝石ならびに美術品
                  </li>
                  <li>
                    &#9314;包装が開封済みの飲食物等（食品類・飲料・酒類）・その他温度、湿度等の管理条件が厳しいものや変質しやすいもの
                  </li>
                  <li>
                    &#9315;ガソリン・シンナー・火薬などの揮発、発火、発熱、引火等しやすいもの
                  </li>
                  <li>
                    &#9316;法令により所有または所持が禁じられているもの（大麻・覚醒剤・盗品・遺骨・遺灰・銃砲・刀剣類など）
                  </li>
                  <li>
                    &#9317;産業廃棄物・建築ガラ・ペンキ等の塗料・薬品・腐敗物・汚染物や異臭・悪臭等を発しているものまたはそのおそれがあるもの
                  </li>
                  <li>
                    &#9318;動物・植物等の生物
                  </li>
                  <li>
                    &#9319;データ・ソフトウェアまたはプログラム等が記載又は記録されたCD、DVD等の媒体その他の有体物
                  </li>
                  <li>
                    &#9320;カビ、サビ、害虫、害獣等の発生しやすいもの
                  </li>
                  <li>
                    &#9321;稿本・設計書・図案・証書・帳簿・その他これらに準ずるもの
                  </li>
                  <li>
                    &#9322;レンタルボックスにおいて保存・保管に適さない状態の収納物（水分を含んだもの、皮脂や汗が付着したままの状態など）
                  </li>
                  <li>
                    &#9323;契約者が自己の責任において管理することができないもの
                  </li>
                  <li>
                    &#9324;他の契約者の収納物、レンタルボックス等に悪影響を与えるおそれがあるもの
                  </li>
                  <li>
                    &#9325;その他、レンタルボックスに収納することが相応しくないと当社が定めるもの
                  </li>
                </ul>
                <p>
                  2.前項にかかわらず、契約者は、屋外型トランクルームについて当社が特別に許可した場合、当社が定める諸規則等及び当社への誓約事項に従うことを条件として自動二輪車及び原動付自転車を収納することができます。
                </p>
              </dd>
              <dt>第14条（契約者の責任）</dt>
              <dd>
                <p>
                  契約者は本件サービスの利用に際し、自己の収納物を自己の責任において管理、保管することはもちろんのこと当社または第三者に損害を与えることがないよう充分に注意を払い、善良な管理者の注意をもってレンタルボックスを使用する責任があります。
                </p>
                <p>
                  2.契約者の家族、従業員その他契約者の関係者（以下「関係者等」といいます）が、契約者の本サービス利用に伴い収納物の搬出搬入等を行う場合も、契約者はその責任の一切を負うこととなり、関係者等の責めに帰すべき事由は、その原因ならびに結果の如何を問わず、契約者の責めに帰すべき事由とみなされます。
                </p>
                <p>
                  3.契約者は定期的にレンタルボックスを訪れ、収納物の現況を点検するものとし、万一契約者の収納物により、カビ等の菌類、サビ、異臭等の発生、その他当社または第三者に悪影響を与えるおそれがあることを発見した場合は直ちに当社に報告をなし、当社の指示に従わなければいけません。なお、これによりレンタルボックス内ならびに施設・敷地の清掃や害虫駆除、他の契約者の収納物を移動、その他当社がなんらかの措置を施す必要が生じた場合には、当社は契約者に対しその費用を請求することができます。
                </p>
                <p>
                  4.当社が別途本件サービス利用に関する利用規則の制定をし、もしくは契約者に対する指示等を行う場合、契約者はこれに従い本件サービスを利用するものとします。
                </p>
                <p>
                  5.契約者は契約者自身または関係者等の責めに帰すべき事由により、当社または第三者に与えた損害については、その全額を賠償する責任を負うものとします。
                </p>
              </dd>
              <dt>第15条（契約者の報告）</dt>
              <dd>
                契約者は、本件サービス利用のため当社に届け出た事項に変更が生じた場合は、当社に対し、直ちに変更後の事項を当社所定の方法にて報告するものとします。なお、変更した事項が契約者の住所・氏名（本店・商号）である場合は、これを証する公的書面（住民票や商業登記簿謄本等）を添えて報告するものとします。
              </dd>
              <dt>第16条（当社の責任の限定）</dt>
              <dd>
                <p>
                  当社は、本件サービスに関して契約者に生じたあらゆる損害について、当社に故意又は重過失があった場合を除き、一切の責任を負いません。
                </p>
                <p>
                  2.前項の規定は、本件サービスの提供に関する当社と契約者との間の契約が消費者契約法（平成12年法律第61号）第2条第3項に定める消費者契約に該当する場合、適用されないものとし、この場合に当社は、当社の過失（本項においては重過失を除く）によって契約者に生じた損害については、直接かつ通常の損害についてのみ責任を負うものとし、損害賠償額は、40万円又は月額使用料の12ヶ月分のいずれか高い金額を上限とします。
                </p>
              </dd>
              <dt>第17条（当社の責任の免責）</dt>
              <dd>
                当社は以下の事由により生じた一切の損害においては、その責任を免責されます。
                <ul>
                  <li>
                    &#9312;地震、津波、風雨、高潮、落雷、大雪、火災、気温や湿度の変化等の自然災害
                  </li>
                  <li>
                    &#9313;戦争、内乱、労働争議、盗難、第三者の不法行為、その他当社にとって不測または突発的な事件事故
                  </li>
                  <li>
                    &#9314;停電、通信障害、その他本サービスに関する施設・設備等における当社にとって不測または突発的な故障、障害
                  </li>
                  <li>
                    &#9315;カビ、サビ、結露、漏水、砂害、虫害、ネズミ等による獣害
                  </li>
                  <li>
                    &#9316;収納物の性質、欠陥、荷造りの不完全、自然消耗、経年劣化等による収納物の滅失、毀損等
                  </li>
                  <li>
                    &#9317;禁止収納物を収納した場合の物品類の滅失、毀損等
                  </li>
                  <li>
                    &#9318;本契約の違反、契約者の管理義務違反、当社が事前に注意を喚起したにも関わらずこれに応じない場合または契約者もしくは関係者等の故意、過失ある場合
                  </li>
                  <li>
                    &#9319;公共事業に関わる収用、区画整理、その他公権力の行使または土地・建物の所有者等から本サービスに関する施設・設備等に対する明渡請求により、本サービスの提供が困難となった場合
                  </li>
                  <li>
                    &#9320;以上の各号に準じる事由のある場合
                  </li>
                </ul>
                <p>
                  2.当社が必要と認めるレンタルボックス及び当該レンタルボックスが設置される物件の修繕・変更・改造、保守作業、並びにこれらに伴う停電、断水その他の使用制限により、契約者の被った損害に対しては、当社はその責めを負わない。<br />
                  ただし、当社の故意又は過失による損害については、本約款第16条に基づく範囲内にて当社は責任を負うものとします。
							  </p>
              </dd>
              <dt>第18条（保険の付保）</dt>
              <dd>
                <p>
                本件サービスは、当社と当社が適当と認めた保険会社（以下「保険会社」といいます）との間で締結される保険契約により、レンタルボックス内に収納された一定の範囲の物品類の火災・盗難による損害を補償するため、当社が適当と認めた内容の損害保険が付保されており、契約者はこれを利用することができます。その内容については、火災、落雷、破裂又は爆発（気体又は蒸気の急激な膨張を伴う破壊又はその現象）、盗難（警察に届出を行う盗難事故をいい、対象となる盗難事故の際における対象の破損及び汚損の損害を含みます。）、水災（台風、暴風雨、豪雨等による洪水、融雪洪水、高潮、土砂崩れ、落石等の水災によって生じた損害。漏水や雨漏りは対象外）となります。<br />
                なお、当該保険により通常のレンタルボックス使用契約において補償される限度額はレンタルボックスのタイプ毎に次のとおりとなりますが、当社が以下の補償限度額を内容とする損害保険を付保していることを契約者に約束するものではなく、変更又は中止される可能性があります。<br />
                また、契約者の特約条件により補償限度額が異なることがあります。
                </p>
                <table>
                  <tr>
                    <th>レンタルボックスのタイプ</th>
                    <th>限度額</th>
                  </tr>
                  <tr>
                    <td>屋外型トランクルーム</td>
                    <td>金500,000円</td>
                  </tr>
                  <tr>
                    <td>屋内型トランクルーム</td>
                    <td>金500,000円</td>
                  </tr>
                </table>
                <p>
                  2.前項の損害保険に基づく補償金の支払いは、保険会社の規約等に基づき行われます。<br />
                  したがって、契約者はそれに従うものとし、上記の限度額を超える損害はもちろんとして限度額内の損害であっても、全ての火災・盗難による損害及び全ての収納物に対し補償されるものではありません。また保険会社の規約等により承認されない損害については、別段の定めによらない限り、当社はその責任を一切負いません。
                </p>
                <p>
                  3.保険会社の変更または保険条件の変更等により随時、補償される限度額・補償範囲が変更または中止される可能性があることのみならず、当社と保険会社との保険契約関係の終了等によって第１項の損害保険を利用できなくなる場合もあることを契約者は予め承諾するものとします。
                </p>
              </dd>
              <dt>第19条（錠･鍵･電子カードキー等）</dt>
              <dd>
                <p>
                  レンタルボックスによっては、当社は契約者に対し本件サービスを利用するための錠、鍵、電子カードキーの貸与もしくは暗証番号（以下総称して「鍵等」といいます）を発行致します。鍵等が貸与・発行されないレンタルボックスに関しては、当社が指定する錠・鍵を契約者が買取り、本件サービスを利用するものとします。
                  <br />
                  なお、当社指定の錠・鍵を使用せず本件サービスを利用した場合は、盗難等につき、補償の対象外となる場合があります。
                </p>
                <p>
                  2.契約者は自己の責任で鍵等を厳格に管理するものとし、鍵等の破損、紛失、盗難、失念、第三者の偽造・盗用、第三者への貸与・譲渡等から発生する契約者および収納物に関する損害については、当社は責任を一切負いません。
                </p>
                <p>
                  3.契約者は貸与された鍵等を複製または第三者に譲渡、貸与、担保提供等をすることはできません。
                </p>
                <p>
                  4.契約者は貸与された鍵等を紛失、盗難、毀損等した場合は直ちに当社に対し、報告し、鍵等の種類に応じて所定の再交付又は再発行に要する費用を支払うものとします。
                </p>
                <p>
                  5.契約が終了した場合、契約者は契約終了日までに当社（郵送の場合は配達証明付の郵便・宅配便にて契約終了日必着）に、貸与された錠、鍵・電子カードキーを返却するものとします。万一当該期日までに、当社がこれらの鍵・電子カードキーの受領を確認できない場合は、契約者において紛失したものとみなし、当社は契約者に前項の再交付手数料を請求することができます。
                </p>
                <p>
                  6.契約者の所有に関わる鍵等であっても、本約款の定めに従って当社がレンタルボックス内に立ち入る場合は、必要に応じて解錠・破壊等を行います。この場合、立ち入る理由が専ら当社の責めに帰すべき事情であるときを除き、当社は損傷した鍵等の費用の負担はしません。
                </p>
              </dd>
              <dt>第19条の２（入館用交通系ICカード）</dt>
              <dd>
                <p>
                  当社は、契約者が屋内型トランクルーム施設の出入りに使用するため、一部の施設につき当社のセキュリティシステムに対応した交通系ICカード（ただし、当社指定のものに限るものとし、以下「ICカード」といいます）を発行し又は契約者が準備したICカードに認証番号を登録し、この場合契約者は、ICカードの発行及び登録に要する費用を負担するものとします。
                </p>
                <p>
                  2.契約者は、自らの管理責任により、ICカードを不正利用されないよう厳格に管理するものとします。
                </p>
                <p>
                  3.契約者は、いかなる場合でもICカードを第三者に譲渡、貸与してはならないものとします。
                </p>
                <p>
                  4.当社は、ICカードの不正利用によって契約者が生じた損害について、別段の定めによらない限り、責任を負いません。当社は、発行又は登録後のICカードに基づく本サービスの利用行為については、すべて契約者に帰属するものとみなすことができ、契約者は、契約者自身の利用とみなされることに同意します。
                </p>
                <p>
                  5.契約者は、ICカードを持参しない場合は、施設に入ることができません。
                </p>
                <p>
                  6.契約者は、ICカードを紛失、盗難、毀損等した場合は直ちに当社に報告するものとし、再発行及び再登録に要する費用を負担するものとします。
                </p>
                <p>
                  7.前項の場合、契約者及び第三者に対して損害が発生したとき、契約者が責任を負うものとし、当社は、責任を負わないものとします。
                </p>
                <p>
                  8.第6項の報告を受けた場合又は本契約が終了した場合、当社は、ICカードの登録を抹消することができるものとします。
                </p>
              </dd>
              <dt>第20条（表明･保証）</dt>
              <dd>
                当社および契約者は、それぞれ相手方に対し、次の各号の事項を確約します。
                <ul>
                  <li>
                    &#9312;自ら（法人の場合は、その役職員、親会社、関係会社、主要株主を含む）が、暴力団、暴力団員、暴力団員でなくなった時から５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団その他これらに準ずる者（以下総称して「反社会的勢力」という）ではないこと
                  </li>
                  <li>
                    &#9313;反社会的勢力と次の関係を有していないこと<br />
                    　ア　自ら若しくは第三者の不正の利益を図る目的、又は第三者に損害を与える目的をもって反社会的勢力を利用していると認められる関係<br />
                    　イ　反社会的勢力に対して資金等を提供し、又は便宜を供与するなど反社会的勢力の維持、運営に協力し、又は関与している関係
                  </li>
                  <li>
                    &#9314;自らの役員（取締役、執行役、執行役員、監査役、相談役、会長その他、名称の如何を問わず、経営に実質的に関与している者をいう）が反社会的勢力ではないこと、及び反社会的勢力と社会的に非難されるべき関係を有していないこと
                  </li>
                  <li>
                    &#9315;反社会的勢力に自己の名義を利用させ、本契約を締結するものではないこと
                  </li>
                  <li>
                    &#9316;自ら又は第三者を利用して本契約に関して次の行為をしないこと<br />
                    　ア　暴力的な要求行為<br / >
                    　イ　法的な責任を超えた不当な要求行為<br />
                    　ウ　取引に関して、脅迫的な言動をし、又は暴力を用いる行為<br />
                    　エ　風説を流布し、偽計又は威力を用いて相手方の業務を妨害し、又は信用を毀損する行為<br />
                    　オ　その他前各号に準ずる行為
                  </li>
                </ul>
                <p>
                  2.甲又は乙の一方について、次のいずれかに該当した場合には、その相手方は、何らの催告を要せずして、本契約を解除することができるものとします。<br />
                  &#9312;前項&#9312;ないし&#9314;の確約に反する表明をしたことが判明した場合<br />
                  &#9313;前項&#9315;の確約に反し契約をしたことが判明した場合<br />
                  &#9314;前項&#9316;の確約に反した行為をした場合
                </p>
                <p>
                  3.前項の規定により本契約が解除された場合には、解除された当事者は、その相手方に対し、相手方の被った損害を賠償するものとします。
                </p>
                <p>
                  4.第2項の規定により本契約が解除された場合には、解除された者は、解除により生じた損害について、その相手方に対し一切の請求を行わないものとします。
                </p>
              </dd>
              <dt>第21条（禁止事項）</dt>
              <dd>
                契約者は本件サービスの利用に際し以下の行為を行ってはなりません。
                <ul>
                  <li>
                    &#9312;レンタルボックスを住居及び事務所等の目的で使用すること、または物品類の収納目的以外で使用すること
                  </li>
                  <li>
                    &#9313;レンタルボックス内外のスペースならびに敷地内において宿泊、滞在、飲酒、飲食、その他物品類の収納・搬出以外の行為をすること
                  </li>
                  <li>
                    &#9314;レンタルボックス内外のスペースならびに施設・敷地内で喫煙、火気類を使用すること
                  </li>
                  <li>
                    &#9315;所定の場所以外に駐車、駐輪すること
                  </li>
                  <li>
                    &#9316;大声、騒音等その他近隣に迷惑・不快感を与えるおそれのある行為をすること
                  </li>
                  <li>
                    &#9317;レンタルボックスの改造、模様替え、釘打ち、ねじ止め、ビス、フック等の設置、シール貼りその他現況を変化させること
                  </li>
                  <li>
                    &#9318;当社が認める場合を除きレンタルボックスに当社が指定する以外の錠・鍵を用いること
                  </li>
                  <li>
                    &#9319;レンタルボックス内以外のスペースに物品類を放置すること
                  </li>
                  <li>
                    &#9320;法令、公序良俗に反すること
                  </li>
                  <li>
                    &#9321;その他、本契約及び別途当社が定める規則に反すること
                  </li>
                </ul>
                <p>
                  2.契約者は、レンタルボックスを転貸（役員構成の変更、株主・社員構成の変更等による事実上これと同じ効果をもたらす行為を含む。）し、または本契約上の権利を第三者に譲渡、担保提供その他これらに準じる処分をすることはできません。
                </p>
                <p>
                  3.当社に対して妥当性を欠く要求をすること、又は社会通念上不相当な言動（当社又は従業員に対する暴行・傷害・脅迫・中傷・名誉棄損・侮辱・暴言・プライバシー侵害行為、正当な理由がない過度な要求、執拗なクレームによる長時間の拘束等を含むがこれらに限られない）をとること。<br />
                  該当する行為を行ったと合理的に判断した場合、当社による電話、電子メール又は書面等一切の対応をお断りすることがあります。
                </p>
              </dd>
              <dt>第22条（立入り・本件サービスの禁止等）</dt>
              <dd>
                <p>
                  当社または当社の指定する業者は、本サービス及び施設・ 設備の維持管理のために点検、補修、工事等を行う場合、 契約者が禁止収納物を収納しているおそれがある場合、そ の他当社がレンタルボックスに立入る必要が生じた場合は、 あらかじめ契約者の承諾を得たうえで、レンタルボックス 内に立ち入り、点検修理その他適切な措置をとることができます。
                </p>
                <p>
                  2.契約者は、正当な理由がある場合を除いて、前項の規定に基づく当社または当社の指定する業者の立ち入りを拒絶しないものとします。
                </p>
                <p>
                  3.前２項にかかわらず、緊急または非常の場合においては、当社または当社の指定する業者は、契約者の事前承諾を得ることなくレンタルボックスに立ち入り、点検修理その他適切な措置をとることができるものとします。
                  <br />
                  この場合、当社または当社の指定する業者は、事後速やかに、その旨を契約者に通知するものとします。
                </p>
              </dd>
              <dt>第23条（契約の解除）</dt>
              <dd>
                当社は、契約者が以下のいずれかに該当したときは、何ら催告または通知をすることなく、直ちに本契約を解除することができます。
                <ul>
                  <li>
                    &#9312;当社から送付した口座振替手続書面が契約者に到達（到達したとみなされる場合を含む）後、１ヶ月以内に口座振替手続きが完了しなかった場合
                  </li>
                  <li>
                    &#9313;利用料金、その他本契約に基づき契約者が支払うべき金銭の支払いを１ヶ月以上遅延したとき
                  </li>
                  <li>
                    &#9314;当社が契約者に対し２週間以上連絡がとれないとき
                  </li>
                  <li>
                    &#9315;禁止収納物の収納または禁止事項に違反したとき
                  </li>
                  <li>
                    &#9316;故意、過失を問わず当社又は第三者に重大な損害を及ぼしたとき
                  </li>
                  <li>
                    &#9317;破産、民事再生、会社更生もしくは特別清算等の申し立て又は事実上倒産状態におちいったとき
                  </li>
                  <li>
                    &#9318;差押、仮差押、仮処分、強制執行、担保権の執行、公売処分、銀行取引停止処分又は租税滞納処分を受けたとき
                  </li>
                  <li>
                    &#9319;当社に対する申告、報告等に虚偽または重要な部分において不正確な表示・必要な記載・資料の省略・誤解を生じさせる方法をしたとき
                  </li>
                  <li>
                    &#9320;契約者もしくは関係者が反社会的勢力であることが発覚したとき、または反社会的勢力のためにレンタルボックスを使用もしくは反社会的勢力をレンタルボックス設置の建物ないし敷地内に出入りさせたとき
                  </li>
                  <li>
                    &#9321;契約者または関係者等が、逮捕・起訴・刑事処分等を受けたとき、もしくは捜査機関より捜査を受けたとき
                  </li>
                  <li>
                    &#9322;その他、法令もしくは公序良俗に違反する場合又は本契約もしくは本サービスに関する利用規則に違反したとき
                  </li>
                </ul>
              </dd>
              <dt>第24条（契約の終了）</dt>
              <dd>
                <p>
                  本契約が、期間満了、期間内解約その他の事由により終了した場合には、契約者は契約終了日までにレンタルボックス内の収納物を搬出・撤去し、貸与を受けた物を返却のうえで、レンタルボックスを原状(通常損耗の場合を除く)に復して当社に明渡すものとします。但し、第23条に基づく当社の解除権の行使もしくは第６条に基づく即時解約により、本契約が即時に終了した場合は、契約者は直ちに上記の明渡しを行うものとします。
                </p>
                <p>
                  2.当社は、契約者から明渡しを受けたレンタルボックスについて、原状回復のための修繕または補修工事が必要であると判断した場合には、必要な修繕を行うものとします。この場合、修繕または補修工事に要した費用は契約者の負担となります。
                </p>
                <p>
                  3.当社は、契約者が自らレンタルボックスを明け渡したにもかかわらず、契約者所有の残置物がある場合、当該残置物の搬出、処分その他の必要な措置を講じることができ、契約者は一切異議等を請求できないものとします。
                </p>
                <p>
                  4.前２項の場合において、当社が負担する費用が生じる場合は、当社はこれらの費用のすべてを契約者に請求できるものとします。
                </p>
                <p>
                  5.安心保証パック特約の保証対応については、本契約終了時の室内整備（点検、シート張替などレンタルボックス内の汚損等の有無及び程度を問わず専門業者により実施される対応を指します）を含み年間５回を上限とし、安心保証パックプラス特約の保証対応については年間10回を上限とします(契約日より起算して１年間毎に回数を算定し、それぞれ上限に満たない年があっても翌年に繰り越されることはありません）。<br />
                  各特約の保証対応の内容などについては、安心保証パック契約約款の定めるところによります。<br />
                  回数を算定し、５回に満たない年があっても翌年に繰り越されることはありません。（保証対象については、安心保証パック契約約款第6条4項を参照）。
                </p>
                <p>
                  6.本契約の終了後であっても明渡しが完了するまでの間は、当社は契約者に対し月額使用料及び月額管理費の2倍に相当する損害金を請求できるものとします。
                </p>
                <p>
                  7.契約期間中ならびに契約の終了時においても、契約者は当社に対し、有益費・必要費・造作買取の請求はできないことはもちろんとして、移動費用、明渡費用その他名目を問わずいかなる金銭を要求することはできません。
                </p>
              </dd>
              <dt>第25条（キャンペーンの適用及び終了）</dt>
              <dd>
                <p>
                  キャンペーンが適用された場合には、利用料金の減額を行うものとします。なお、減額の対象、期間、および減額後の金額は、当社が別途定めるものとします。
                </p>
                <p>
                  2.次の場合、キャンペーンは終了となります。
                </p>
                <ul>
                  <li>
                    &#9312;キャンペーン適用期間が満了した場合
                  </li>
                  <li>
                    &#9313;契約期間中に２ヶ月間連続で月額使用料、管理費またはその他の支払が遅延した場合
                  </li>
                </ul>
                <p>
                  3.キャンペーンが終了した場合、キャンペーン終了月の翌月以降の利用料金は、使用契約申込書等に記載の金額となります。
                </p>
              </dd>
              <dt>第26条（個人情報の取扱について）</dt>
              <dd>
                <p>
                  当社はご提供頂いた個人情報につきましては、下記の目的の範囲内で取り扱いさせていただきます。
                </p>
                <ul>
                  <li>
                    &#9312;ご本人確認、ご利用料金の請求及びご利用料金・ご利用サービス提供条件の変更、ご利用サービスの停止・中止・契約解除の通知並びに当社サービスの提供。
                  </li>
                  <li>
                    &#9313;電話、FAX、電子メール郵便等各種媒体により、当社並びに当社グループのサービスに関する販売推奨・アンケート調査並びに景品等の送付。
                  </li>
                </ul>
                <p>
                  2.当社はご提供いただいた個人情報につきましては、上記利用目的を達成するため、業務委託先又は提携先に開示する場合があります。また、法令等に基づき裁判所、警察機関などの公的機関から開示の要請があった場合には、当該公的機関に提供することがあります。当社は以上の方針を改定することがあります。その場合、すべての改定は、改定の時点で第1条4項にしたがって行われるものとします。
                </p>
                <p>
                  3.当社は、ご提供頂いた個人情報を本約款のほか、 当社の定めるプライバシーポリシーに従って適切に取り扱いさせていただきます。
                </p>
                <p>
                  4.当社は、ご提供頂いた個人情報を本契約終了後も本約款およびプライバシーポリシーに定めている利用目的の範囲で個人情報を利用します。
                </p>
              </dd>
              <dt>第27条（通知及び意思表示）</dt>
              <dd>
                <p>
                  当社が契約者に対する通知、連絡ならびに意思表示を本契約に表示された契約者の連絡先（第15条により変更の届出があった場合は、当該変更後の住所）に宛てに書面（電子メールを含む）を発送した場合は、当該通知等が通常到達すべき時に到達したものとみなします。
                </p>
                <p>
                  2.当社は契約者からの通知、連絡及び意思表示を当社が指定する書面によって行うことを請求することができます。この場合、当該書面の当社への到達をもって、有効な通知、連絡及び意思表示があったものとします。
                </p>
              </dd>
              <dt>第28条（協議事項）</dt>
              <dd>
                本契約に定めがない事項が生じた場合は本契約の趣旨に基づき当社と契約者の間で協議し、これを解決するものとします。
              </dd>
              <dt>第29条（合意管轄）</dt>
              <dd>
                本契約に関し万一紛争が生じた場合は、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
              </dd>
              <dt>附則</dt>
              <dd>
                契約者は、本件サービスの利用料金等について法令の定めるところに従い消費税を追加して支払うものとします。なお、契約期間中に消費税率の変動があった場合、変動のあった日より当然に新消費税率が適用され、以後その消費税率で計算された消費税をお支払いいただきます。
              </dd>
            </dl>
            <p className="right mt10">
              2024年1月10日改定　エリアリンク株式会社
            </p>
          </div>
          <div className="kiyakuDetail">
            <h2 className="mt20">バイクパーキング誓約書</h2>
            <p className="red bold">
              ※レンタル収納スペースをバイク駐車場として使用する場合、以下事項について誓約したものといたします。
            </p>
            <dl>
              <dd>
                貴社のバイク駐車場である、レンタル収納スペースを一時使用するにあたり、下記の禁止事項を厳守し、免責事項につき同意することを誓約いたします。
                なお、下記禁止事項に対する違反行為があった場合には、貴社が何ら催告または通知をすることなく、直ちに契約解除できることをあらかじめ承諾し、当該解約通知に対し、一切異議申し立てしないことを誓約いたします。
              </dd>
              <br />
              <dt className="center">記</dt>
              <dt>1. 禁止事項</dt>
              <dd>
                <p>1. 駐車場内での洗車、修理などの作業</p>
                <p>2. 駐車場内での喫煙、飲食</p>
                <p>3. 駐車場内及び私道、その他指定された場所でのエンジン始動</p>
                <p>4. 契約者以外の駐車場内への立ち入り</p>
                <p>5. 契約車両以外の駐車</p>
                <p>6. その他、近隣の迷惑となる行為</p>
              </dd>
              <dt>2. 貴社の免責事項</dt>
              <dd>
                <p>
                  　貴社に対し、駐車場内での事故・火災・盗難・その他故障などに対する損害賠償請求を
                  いたしません。また、レンタルボックス使用契約申込書第１８条の規程は、今般、私と貴
                  社との間で締結するバイク駐車場の使用契約の際には及ばないことを確認しました。
                </p>
                <br />
                <p>以上</p>
              </dd>
            </dl>
            <p className="right mt10">
              附則 2016年7月6日制定　エリアリンク株式会社
            </p>
            <h2>安心保証パック契約約款
            <a className="link_pdf2" href="/resource/img/static/agreement/anpo_yakkan_20230401.pdf?20230401" target="_blank">ダウンロード</a>
            </h2>
            <p className="red bold">
            ※安心保証パック特約または安心保証パックプラス特約にご加入の方は必ずお読みください。
            </p>
            <dl>
              <dt>第1条（総則）</dt>
              <dd>
                <p>
                本安心保証パック契約約款（以下「本保証約款」といいます。）は、エリアリンク株式会社（以下「当社」といいます。）と当社が提供する「レンタルボックス使用サービス」及びこれに付随するオプションサービス（以下総称して「本件サービス」といいます。）の利用をレンタルボックス使用契約申込書（当社ホームページからの申込みまたは電話にて申込み後、使用契約申込書を当社へ提出する場合を含む。）により次項に定める本約款及び本保証約款を契約の内容とすることを承諾のうえで申込み、当社がこれを承諾した個人または法人（以下「契約者」といいます。）との間における、本件サービスの利用に関する「安心保証パック特約」及び「安心保証パックプラス特約」（以下「本オプションサービス」といいます。）に対して適用されます。
                </p>
                <p>
                  2.本保証約款に定める規定は全てレンタルボックス使用契約約款（以下「本約款」といいます。）に準じるものとし、本保証約款に記載されていない内容で特段の規定がないものについては、本約款に記載されている内容によるものとします。
                </p>
                <p>
                  3.本保証約款において使用する用語で特段の規定がないものについては、本約款の用語の定義によるものとします。
                </p>
                <p>
                  4.当社は本保証約款を変更することがあります。この場合、当社は契約者への書面（電子メールを含む）による通知または当社ホームページにおいて本保証約款を変更する旨及び変更後の本約款の内容並びにその効力発生日の告知を行うものとし、かかる効力発生日以降は、変更後の約款が適用され、契約者は変更後の約款を承認して本オプションサービスを利用するものとみなされます。
                </p>
              </dd>
              <dt>第2条（定義）</dt>
              <dd>
                <p>
                「安心保証パック特約」とは、レンタルボックス使用契約を締結する際に同時に申し込むことで、鍵等の紛失、警備会社出動対応、及び室内整備料の費用負担が免責される手軽かつ安心な保証サービスをいいます。
                </p>
                <p>
                  2.「安心保証パックプラス特約」とは、前項に定める保証サービスに加え年間の適用回数（本保証約款第7条参照）及び保険による補償限度額（本約款第18条参照）において、より安心な保証サービスをいいます。
                </p>
              </dd>
              <dt>第3条（申込み）</dt>
              <dd>
                <p>
                本オプションサービスの申込みは、原則、契約者が、レンタルボックス使用サービスの新規契約と同時に申込むものとします。
                なお、本オプションサービスはレンタルボックスを複数契約した場合にも、契約ごとに申し込むものとします。
                </p>
              </dd>
              <dt>第4条（サービス料金）</dt>
              <dd>
                <u className="bold">
                本オプションサービスの料金は、安心保証パック特約が付された契約者については、特約料として月額550円（税込）、安心保証パックプラス特約を付された契約者については、特約料として月額880円（税込）を支払うものとします。
                </u>
                <p>
                  2.前項に定める本オプションサービスの月額特約料は、契約月に従って計算するものとし、契約月の途中で加入・解除があった場合は、日割り計算はしないものとします。
                </p>
              </dd>
              <dt>第5条（サービス料の無料期間）</dt>
              <dd>
                <p>
                当社は、当社の定める条件を満たす契約者に対して、月額サービス料を一定期間無料とする場合があります。
                </p>
              </dd>
              <dt>第6条（各保証サービスの概要）</dt>
              <p>
                1.コンテナタイプのレンタルボックスを使用されている場合のみのサービス
              </p>
              <p>１）カード型鍵紛失時のサービス</p>
              <dd>
                <ul>
                  <li>
                    &#9312;カード型の鍵を紛失した場合、無料で鍵交換及び新しい鍵を契約者の連絡先（以下「届出住所」といいます。）へ発送します。
                  </li>
                  <li>
                    &#9313;カード型鍵紛失の申出から発送までは当社所定の期間内とします。
                  </li>
                  <li className="bold">
                    <u>
                    &#9314;緊急対応については、別途、金１６，５００円（税込）を請求します。
                    </u>
                  </li>
                  <li className="bold">
                    （※緊急対応とは、定期的な管理会社の巡回とは異なり、本約款第１２条に基づく特別出勤をいいます。以下、同じ。）
                  </li>
                </ul>
              </dd>
              <p>
                2.トランクルームタイプのレンタルボックスを使用されている場合のみのサービス
              </p>
              <p>１）セキュリティカード再発行サービス</p>
              <dd>
                <ul>
                  <li>
                    &#9312;レンタルボックス入館時に必要なセキュリティカードを紛失した場合や、磁気不良や破損により使用できなくなった場合、無料でセキュリティカードを再発行し、届出住所へ発送します。
                    <br />
                    ただし、セキュリティカードが不要なレンタルボックスもあります。
                  </li>
                  <li>
                    &#9313;セキュリティカードの再発行の申出から発送までは当社所定の期間内とします。
                  </li>
                  <li className="bold">
                    <u>
                    &#9314;緊急対応については、別途、金１６，５００円（税込）を請求します。
                    </u>
                  </li>
                </ul>
              </dd>
              <p>２）シリンダーキー再発行サービス</p>
              <dd>
                <ul>
                  <li>
                    &#9312;シリンダーキータイプのレンタルボックス利用時、シリンダーキーを紛失した場合、無料でシリンダーキーを新しいものと交換し、届出住所に発送します。
                  </li>
                  <li>
                    &#9313;シリンダーキーの再発行の申出から発送までは当社所定の期間内とします。
                  </li>
                  <li className="bold">
                    <u>
                    &#9314;緊急対応については、別途、金１６，５００円（税込）を請求します。
                    </u>
                  </li>
                </ul>
              </dd>
              <p>３）レンタル南京錠紛失時のサービス</p>
              <dd>
                <ul>
                  <li>
                    &#9312;レンタル南京錠の鍵を紛失してしまった場合、無料で元の南京錠を開錠し、新たな南京錠を契約者の連絡先（以下「届出住所」といいます。）へ発送します。
                  </li>
                  <li>
                    &#9313;レンタル南京錠紛失の申出から発送までは当社所定の期間内とします。
                  </li>
                  <li className="bold">
                    <u>
                    &#9314;緊急対応については、別途、金１６，５００円（税込）を請求します。
                    </u>
                  </li>
                </ul>
              </dd>
              <p>４）緊急出動発生時のサービス</p>
              <dd>
                <p>
                ドアインロックの発生時、担当警備会社による緊急対応費用が無料となります。
                  <br />
                  ただし、契約者本人の確認のため、本人確認書類（運転免許証、健康保険証等）の提示が必要となります。
                </p>
              </dd>
              <p>3.両タイプ共通のサービス</p>
              <p>１）ダイヤル錠紛失時のサービス</p>
              <dd>
                <p>
                契約時に仮止めしてあるダイヤル式南京錠を紛失した場合、新たな南京錠を届出住所へ発送します。
                </p>
              </dd>
              <p>２）南京錠紛失時のサービス</p>
              <dd>
                <ul>
                  <li>
                    &#9312;南京錠を紛失した場合、無料で鍵の切断費用および新しい南京錠を届出住所へ発送します。
                  </li>
                  <li>
                    &#9313;南京錠を紛失した場合、無料で鍵の切断費用および新しい南京錠を届出住所へ発送します。
                  </li>
                  <li className="bold">
                    <u>
                    &#9314;③緊急対応については、別途、金１６，５００円（税込）を請求します。
                    </u>
                  </li>
                </ul>
              </dd>
              <p>３）室内整備料のサービス</p>
              <dd>
                <p>
                レンタルボックス解約時に発生する本約款第７条6号に定める室内整備料を無料といたします。
                </p>
              </dd>
              <p>４）レンタルボックスの変更・追加に伴う事務手数料無料のサービス</p>
              <dd>
                <p>
                レンタルボックスの変更又は追加申込みされる時に発生する本約款第７条3号に定める事務手数料を無料といたします。
                    <br />
                    ただし、当初ご利用のレンタルボックスご利用開始月を１か月目としてご利用開始月から２か月を経過した後に変更又は追加申込される方を対象にサービスの適用とします。
                </p>
              </dd>
              <p>５）レンタルボックスに付保されている保険限度額の増額サービス</p>
              <dd>
                <p>
                安心保証パックプラス特約に加入された場合に限り、本約款第18条に定める補償限度額を金1,000,000円までとします。
                </p>
              </dd>
              <dd>
                <table className="mt10">
                  <tr>
                    <th>保証対応</th>
                    <th>部屋タイプ</th>
                    <th>通常料金(税込)</th>
                    <th>保証パック</th>
                  </tr>
                  <tr>
                    <td>カード型鍵紛失</td>
                    <td>コンテナ</td>
                    <td>11,000円</td>
                    <td rowSpan="9">全て無料</td>
                  </tr>
                  <tr>
                    <td>セキュリティカード再発行</td>
                    <td>トランクルーム</td>
                    <td>11,000円</td>
                  </tr>
                  <tr>
                    <td>シリンダーキー再発行</td>
                    <td>トランクルーム</td>
                    <td>11,000円</td>
                  </tr>
                  <tr>
                    <td>レンタル南京錠紛失</td>
                    <td>トランクルーム</td>
                    <td>11,000円</td>
                  </tr>
                  <tr>
                    <td>警備会社出動対応</td>
                    <td>トランクルーム</td>
                    <td>3,300円</td>
                  </tr>
                  <tr>
                    <td>ダイヤル錠紛失</td>
                    <td>トランクルーム・コンテナ</td>
                    <td>3,300円</td>
                  </tr>
                  <tr>
                    <td>南京錠紛失（切断費用込）</td>
                    <td>トランクルーム・コンテナ</td>
                    <td>11,000円</td>
                  </tr>
                  <tr>
                    <td>室内整備料</td>
                    <td>トランクルーム・コンテナ</td>
                    <td>8,800円</td>
                  </tr>
                  <tr>
                    <td>事務手数料</td>
                    <td>トランクルーム・コンテナ</td>
                    <td>使用料１か月分</td>
                  </tr>
                </table>
              </dd>
              <dt>第7条（適用回数および適用制限）</dt>
              <dd>
                <p className="bold">
                  １．<u>本オプションサービスの保証対応は、安心保証パック特約においては年間５回を上限とし、安心保証パックプラス特約においては年間10回を上限とします(契約日より起算して１年間毎に回数を算定し、それぞれの上限回数に満たない年があっても翌年に繰り越されることはありません)。</u>
                </p>
                <p className="bold">
                  ２．<u>滞納期間中には、本オプションサービスの保証対応を受けることはできません。</u>
                </p>
              </dd>
              <dt>第8条（解約手続）</dt>
              <dd>
                <u className="bold">
                 契約者が本オプションサービスの解約を希望する場合には、当社への電話での申出によるものとし、申出日の翌月末をもって解約されたものとします。なお、解約後、再加入はできません。<br />
                 また、本オプションサービスのみを中途解約した場合には、本保証約款第7条1項6号に定める室内整備料8800円を支払うものとします。
                </u>
              </dd>
              <dt>第9条（契約の終了）</dt>
              <dd>
                <p>
                レンタルボックス使用契約が終了した場合は、本オプションサービスも同時に終了します。
                </p>
              </dd>
            </dl>
            <p className="right mt10">
              2023年4月1日改定　エリアリンク株式会社
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/agreement.jsx